import React from "react";
import PropTypes from "prop-types";
import { Backdrop, CircularProgress } from "@mui/material";
import { styled } from "@mui/system";

const BlurredBackdrop = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  backgroundColor: "rgba(255, 255, 255, 0.5)",
  backdropFilter: "blur(5px)",
}));

const LoadingOverlay = ({ isLoading }) => {
  return (
    <BlurredBackdrop open={isLoading}>
      <CircularProgress color="primary" />
    </BlurredBackdrop>
  );
};

LoadingOverlay.propTypes = {
  isLoading: PropTypes.bool.isRequired,
};

export default LoadingOverlay;
